import store from '@/store';
export const option = {
    height: 'auto',
    calcHeight: 80,
    tip: false,
    delBtn: false,
    editBtn: false,
    addBtn: true,
    searchShow: true,
    searchMenuSpan: 6,
    searchLabelWidth: 100,
    labelWidth: 150,
    border: true,
    index: true,
    selection: false,
    viewBtn: false,
    dialogType: 'dialog',
    dialogClickModal: false,
    column: [{
            label: "保证金公司名称",
            prop: "securityDeptName",
            type: "input",
            search: true,
            searchOrder: 100,
            span: 24,
            searchLabelWidth: 120,
            rules: [{
                required: true,
                message: "请输入保证金公司名称",
                trigger: "blur",
            }, ],
        },
        {
            label: "公司名称",
            prop: "deptId",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 10,
            hide: true,
            dicData: [],
            props: {
                label: "deptName",
                value: "id",
            },
        },
        {
            label: "绑定公司",
            prop: "deptIds",
            type: "select",
            span: 24,
            filterable: true,
            search: false,
            multiple: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 10,
            dicData: [],
            props: {
                label: "deptName",
                value: "id",
            },
            rules: [{
                required: true,
                message: "请选择绑定公司",
                trigger: "change",
            }, ],
        },
        {
            label: "使用时间",
            prop: "currentLendingDate",
            type: "date",
            search: true,
            searchRange: true,
            searchType: "daterange",
            valueFormat: "yyyy-MM-dd",
            display: false,
            hide: true,
        },
        {
            label: "id",
            prop: "id",
            display: false,
            hide: true,
        },
        {
            label: "保证金金额",
            prop: "securityMoney",
            display: false,
        },
        {
            label: "保证金余额",
            prop: "securityMoneyBalance",
            search: false,
            display: false,
        },
        {
            label: "代理商占用额",
            prop: "agentOccupancy",
            display: false,
        },
        {
            label: "品融垫付金额",
            prop: "prDisbursements",
            display: false,
        },
        {
            label: "车300估值（代理商）",
            prop: "agentChe300AssessPrice",
            display: false,
        },
        {
            label: "车300估值（品融）",
            prop: "prChe300AssessPrice",
            display: false,
        },
        {
            label: "大数据（代理商）",
            prop: "agentBigdataPrice",
            display: false,
        },
        {
            label: "大数据（品融）",
            prop: "prBigdataPrice",
            display: false,
        },
        {
            label: "法大大合同（代理商）",
            prop: "agentFascPrice",
            display: false,
        },
        {
            label: "法大大合同（品融）",
            prop: "prFascPrice",
            display: false,
        },
        {
            label: "维修记录（代理商）",
            prop: "agentMaintenancePrice",
            display: false,
        },
        {
            label: "维修记录（品融）",
            prop: "prMaintenancePrice",
            display: false,
        },
        {
            label: "出险记录（代理商）",
            prop: "agentInsuranceProce",
            display: false,
        },
        {
            label: "出险记录（品融）",
            prop: "prInsuranceProce",
            display: false,
        },
        // {
        //     label: "征信报告（代理商）",
        //     prop: "agentInvestigationPrice",
        //     display: false,
        // },
        // {
        //     label: "征信报告（品融）",
        //     prop: "prInvestigationPrice",
        //     display: false,
        // }
    ],
}
